module.exports = __webpack_public_path__ + "static/media/iheartradio.9fb1c1a2.svg";